// Copyright 2025, University of Maryland, All Rights Reserved
import { useQuery } from '@tanstack/react-query';
import { getWorkspacesApi } from './api';
import type {
  NodeLLMOverviewItem,
  UpdateNodeLLMRequest,
} from '../types/llm-node-overview';

export type LLMOverviewApi = ReturnType<typeof useLLMOverviewApi>;

export const llmOverviewKeys = {
  all: ['llm-node-overview'] as const,
};

export function useLLMNodeOverview() {
  const api = useLLMOverviewApi();
  return useQuery<NodeLLMOverviewItem[]>({
    queryKey: llmOverviewKeys.all,
    queryFn: api.listNodeLLMOverview,
    staleTime: 60_000,
  });
}

export const useLLMOverviewApi = () => {
  const apiInstance = getWorkspacesApi();

  return {
    listNodeLLMOverview: async (): Promise<NodeLLMOverviewItem[]> => {
      const response = await apiInstance.get<NodeLLMOverviewItem[]>('/admin/llm-overview');
      return response.data;
    },

    updateNodeLLM: async (
      orgId: string,
      wsId: string,
      pipelineId: string,
      instanceId: string,
      data: UpdateNodeLLMRequest,
    ): Promise<NodeLLMOverviewItem> => {
      const url = `/admin/llm-overview/${encodeURIComponent(orgId)}/${encodeURIComponent(wsId)}/${encodeURIComponent(pipelineId)}/${encodeURIComponent(instanceId)}`;
      const response = await apiInstance.patch<NodeLLMOverviewItem>(url, data);
      return response.data;
    },
  };
};
